/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectCompanyFieldDto } from '../../models/backend-project-company-field-dto';
import { BackendProjectCompanyFieldRequestDto } from '../../models/backend-project-company-field-request-dto';

export interface ProjectsProjectCompanyUpdate$Params {
  id: number;
  body?: BackendProjectCompanyFieldRequestDto;
}

export function projectsProjectCompanyUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectCompanyUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectCompanyUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectCompanyFieldDto>;
    }),
  );
}

projectsProjectCompanyUpdate.PATH = '/api/projects/project_company/{id}/';
